import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigator } from "../../redux/NavigationStore";

export const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  return <>{children}</>;
};
